
const digest = '5072c56cae1f2693ed3113380dc16a87338993da6044cfc4986799f2d67b62d4';
const classes = {"wrapper":"_wrapper_1c89n_1","input":"_input_1c89n_5","suffix":"_suffix_1c89n_24","prefix":"_prefix_1c89n_33","withPrefix":"_withPrefix_1c89n_42","withSuffix":"_withSuffix_1c89n_46","errorMessage":"_errorMessage_1c89n_50","invalid":"_invalid_1c89n_56"};
const css = `._wrapper_1c89n_1 {
  position: relative;
}

._input_1c89n_5 {
  border: 1px solid #e2e5ed;
  min-height: 55px;
  font-family: Poppins, sans-serif;
  font-size: 14px;
  font-weight: 400;
  border-right: 0;
  border-radius: 24.5px;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  padding: 16px 20px;
  color: #000;
  background-color: #fff;
}
._input_1c89n_5:focus {
  box-shadow: 0 0 0 3px rgba(22, 101, 216, 0.15), inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-color: #1665d8;
  color: #000;
}

._suffix_1c89n_24 {
  font-family: Poppins, sans-serif;
  position: absolute;
  font-size: 14px;
  color: #1665d8;
  right: 20px;
  bottom: 15px;
}

._prefix_1c89n_33 {
  left: 20px;
  font-family: Poppins, sans-serif;
  position: absolute;
  font-size: 14px;
  color: #1665d8;
  bottom: 17px;
}

._withPrefix_1c89n_42 {
  padding-left: 50px;
}

._withSuffix_1c89n_46 {
  padding-right: 50px;
}

._errorMessage_1c89n_50 {
  font-family: Poppins, sans-serif;
  font-size: 14px;
  color: #d81616;
}

._invalid_1c89n_56 {
  border-color: #d81616 !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
  background-repeat: no-repeat;
  background-position: center right calc(0.375em + 0.1875rem);
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  